import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';

// primeNg
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from "primeng/menubar";
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from "primeng/panel";
import { PickListModule } from 'primeng/picklist';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from "primeng/togglebutton";
import { MenubarComponent } from '../@share/menubar/menubar.component';
import { ProgressModule } from '../@share/progress/progress.module';
import { PipesModule } from '../pipes/pipes.module';
import { BudgetPdfPreviewComponent } from './budget/preview/budget-pdf-preview.component';



@NgModule({
  declarations: [PagesComponent, MenubarComponent, BudgetPdfPreviewComponent],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    MenubarModule,
    PanelModule,
    BreadcrumbModule,
    SlideMenuModule,
    ToastModule,
    ConfirmDialogModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    CheckboxModule,
    RadioButtonModule,
    CardModule,
    AutoCompleteModule,
    SelectButtonModule,
    DialogModule,
    ToggleButtonModule,
    InputNumberModule,
    ProgressModule,
    CalendarModule,
    PipesModule,
    SidebarModule,
    InputTextModule,
    PdfViewerModule,
   
  ],
  exports: [
    ToastModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    ButtonModule,
    TableModule,
    DropdownModule,
    PanelModule,
    InputTextModule,
    CheckboxModule,
    RadioButtonModule,
    CardModule,
    AutoCompleteModule,
    SelectButtonModule,
    DialogModule,
    ToggleButtonModule,
    InputNumberModule,
    MenubarModule,
    ProgressModule,
    SidebarModule,
    MultiSelectModule,
    CalendarModule,
    PickListModule,
    BadgeModule,
    PipesModule,
    InputTextModule,
    BudgetPdfPreviewComponent
  ]
})
export class PagesModule { }
